'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const DetailsOverview = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '1rem',
    width: '100%',
    'a' : {
        color: theme.palette.custom?.link,
    },
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
    },
}));

export default DetailsOverview;
